import i18next from 'util/i18n'

export const RISK_TYPE_I18N_NS = 'riskTypes'

export const RISK_TYPE_HOME = 'home'
export const RISK_TYPE_HOME_CUSTOM = 'homeCustom'
export const RISK_TYPE_HOME_PACKAGE = 'homePackage'
export const RISK_TYPE_HOME_REQUOTE = 'homeRequote'
export const RISK_TYPE_PHONE = 'phone'
export const RISK_TYPE_COMPUTER = 'computer'
export const RISK_TYPE_CONSORTIUM = 'consortium'
export const RISK_TYPE_COMMERCE = 'commerce'
export const RISK_TYPE_BICYCLE = 'bicycle'
export const RISK_TYPE_CAR = 'car'
export const RISK_TYPE_MOTO = 'motorcycle'
export const RISK_TYPE_LIFE = 'life'
export const RISK_TYPE_MOBILITY = 'mobility'
export const RISK_TYPE_PERSONAL_ACCIDENT = 'personalAccident'
export const RISK_TYPE_LABORAL_INSURED = 'laboralInsured'
export const RISK_TYPE_GUARANTEE_INSURANCE = 'guaranteeInsurance'
export const RISK_TYPE_CIVIL_RESPONSIBILITY = 'civilResponsibility'
export const RISK_TYPE_TRANSPORT = 'transport'
export const RISK_TYPE_OTHERS = 'others'
export const RISK_TYPE_FLOTA = 'flota'

export const RISK_TYPE_ROUTE_CAR = 'auto'
export const RISK_TYPE_ROUTE_MOTO = 'moto'

export const RISK_TYPE = {
    HOME: RISK_TYPE_HOME,
    HOME_CUSTOM: RISK_TYPE_HOME_CUSTOM,
    HOME_PACKAGE: RISK_TYPE_HOME_PACKAGE,
    HOME_REQUOTE: RISK_TYPE_HOME_REQUOTE,
    PHONE: RISK_TYPE_PHONE,
    COMPUTER: RISK_TYPE_COMPUTER,
    CONSORTIUM: RISK_TYPE_CONSORTIUM,
    COMMERCE: RISK_TYPE_COMMERCE,
    BICYCLE: RISK_TYPE_BICYCLE,
    CAR: RISK_TYPE_CAR,
    MOTORCYCLE: RISK_TYPE_MOTO,
    LIFE: RISK_TYPE_LIFE,
    MOBILITY: RISK_TYPE_MOBILITY,
    AP: RISK_TYPE_PERSONAL_ACCIDENT,
    HOME_LIST: [RISK_TYPE_HOME, RISK_TYPE_HOME_CUSTOM, RISK_TYPE_HOME_PACKAGE, RISK_TYPE_HOME_REQUOTE],
    MICRO_INSURANCE_LIST: [RISK_TYPE_PHONE, RISK_TYPE_COMPUTER, RISK_TYPE_BICYCLE, RISK_TYPE_LIFE],
    CAN_REQUOTE: [RISK_TYPE_HOME, RISK_TYPE_HOME_CUSTOM, RISK_TYPE_CONSORTIUM, RISK_TYPE_COMMERCE],
    VEHICLE_LIST: [RISK_TYPE_CAR, RISK_TYPE_MOTO],
    ACCIDENT_VEHICLE_LIST: [RISK_TYPE_CAR, RISK_TYPE_MOTO, RISK_TYPE_FLOTA],
}

export const RISK_TYPE_CONFIG = {
    [RISK_TYPE_CAR]: {
        key: 'car',
        routeSegment: null,
        routeType: RISK_TYPE_ROUTE_CAR,
        supportsGnc: true,
        supportsLegalPerson: true,
        supportsAdvancedConfig: true,
    },
    [RISK_TYPE_MOTO]: {
        key: 'motorcycle',
        routeSegment: null,
        routeType: RISK_TYPE_ROUTE_MOTO,
        supportsGnc: false,
        supportsLegalPerson: false,
        supportsAdvancedConfig: false,
    },
    [RISK_TYPE_HOME]: {
        key: 'home',
        routeSegment: 'hogar',
    },
    [RISK_TYPE_HOME_CUSTOM]: {
        key: 'homeCustom',
        routeSegment: 'hogar-personalizado',
    },
    [RISK_TYPE_HOME_PACKAGE]: {
        key: 'homePackage',
        routeSegment: 'hogar-paquetizado',
    },
    [RISK_TYPE_HOME_REQUOTE]: {
        key: 'homeRequote',
        routeSegment: 'hogar-recotizar',
    },
    [RISK_TYPE_COMMERCE]: {
        key: 'commerce',
        routeSegment: 'comercio',
    },
    [RISK_TYPE_CONSORTIUM]: {
        key: 'consortium',
        routeSegment: 'consorcio',
    },
    [RISK_TYPE_BICYCLE]: {
        key: 'bicycle',
        routeSegment: 'bicicleta',
    },
    [RISK_TYPE_COMPUTER]: {
        key: 'computer',
        routeSegment: 'computadora',
    },
    [RISK_TYPE_PHONE]: {
        key: 'phone',
        routeSegment: 'celular',
    },
    [RISK_TYPE_LIFE]: {
        key: 'life',
        routeSegment: 'vida',
    },
    [RISK_TYPE_MOBILITY]: {
        key: 'mobility',
        routeSegment: null,
    },
    [RISK_TYPE_PERSONAL_ACCIDENT]: {
        key: 'personalAccident',
        routeSegment: null,
    },
    [RISK_TYPE_LABORAL_INSURED]: {
        key: 'laboralInsured',
        routeSegment: null,
    },
    [RISK_TYPE_GUARANTEE_INSURANCE]: {
        key: 'guaranteeInsurance',
        routeSegment: null,
    },
    [RISK_TYPE_CIVIL_RESPONSIBILITY]: {
        key: 'civilResponsibility',
        routeSegment: null,
    },
    [RISK_TYPE_TRANSPORT]: {
        key: 'transport',
        routeSegment: null,
    },
    [RISK_TYPE_OTHERS]: {
        key: 'others',
        routeSegment: null,
    },
    [RISK_TYPE_FLOTA]: {
        key: 'flota',
        routeSegment: null,
    },
}

const ROUTE_SEGMENT_TO_RISK_TYPE = Object.fromEntries(
    Object.entries(RISK_TYPE_CONFIG)
        .filter(([, config]) => config.routeSegment)
        .map(([riskType, config]) => [config.routeSegment, riskType])
)

export const getRiskTypeConfig = (type) => RISK_TYPE_CONFIG[type] ?? null

export const getRiskTypeKey = (type) => RISK_TYPE_CONFIG[type]?.key ?? type

export const getRiskTypeLabel = (type, t = i18next.t.bind(i18next)) => {
    if (!type) return type

    return t(`${RISK_TYPE_I18N_NS}:${getRiskTypeKey(type)}`)
}

export const resolveRiskTypeLabel = (type, apiOptions, t = i18next.t.bind(i18next)) => {
    if (!type) return type

    const fromApi = apiOptions?.find(({ id }) => id === type)?.value
    return fromApi ?? getRiskTypeLabel(type, t)
}

export const getRiskTypeId = (riskType) =>
    typeof riskType === 'string' ? riskType : riskType?.id

export const getPublicRiskTypeOptions = (t = i18next.t.bind(i18next)) => (
    Object.keys(RISK_TYPE_CONFIG)
        .filter((type) => type === RISK_TYPE_HOME || !RISK_TYPE.HOME_LIST.includes(type))
        .map((id) => ({
            id,
            value: getRiskTypeLabel(id, t),
        }))
)

export const isCarRiskType = (riskType) => getRiskTypeId(riskType) === RISK_TYPE_CAR

export const isMotoRiskType = (riskType) => getRiskTypeId(riskType) === RISK_TYPE_MOTO

export const isQuoteVehicleRiskType = (riskType) =>
    RISK_TYPE.VEHICLE_LIST.includes(getRiskTypeId(riskType))

export const isVehicleRiskType = (riskType) =>
    RISK_TYPE.ACCIDENT_VEHICLE_LIST.includes(getRiskTypeId(riskType))

export const riskTypeToRoute = (type) => {
    if (!type) return type

    return RISK_TYPE_CONFIG[type]?.routeSegment ?? type
}

export const routeToRiskType = (route) => {
    if (!route) return route

    return ROUTE_SEGMENT_TO_RISK_TYPE[route] ?? route
}

export const routeTypeToRiskType = (routeType) => {
    if (routeType === RISK_TYPE_ROUTE_MOTO) {
        return RISK_TYPE_MOTO
    }

    if (routeType === RISK_TYPE_ROUTE_CAR) {
        return RISK_TYPE_CAR
    }

    return null
}

export const riskTypeToRouteType = (type) => RISK_TYPE_CONFIG[type]?.routeType ?? null

export const typeToRoute = riskTypeToRoute
export const routeToType = routeToRiskType
